import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";

function DequipoCirugiaAutoevaluacion({ id, onDeleted }) {
  const eliminar = () => {
    if (!window.confirm("¿Desea eliminar este registro?")) return;

    axios
      .delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaAutoevaluacion/" +
          id,
      )
      .then(() => {
        alert("Eliminado con éxito");
        onDeleted(); // ⬅️ AVISA AL PADRE
      })
      .catch((error) => {
        console.log(error);
        alert("Error al eliminar");
      });
  };

  return (
    <button className="btn btn-danger btn-sm" onClick={eliminar}>
      <IoIcons.IoIosCloseCircleOutline size={18} />
    </button>
  );
}

export default DequipoCirugiaAutoevaluacion;
